import { ICondition, IProfessionalQualification } from '@medely/types';
import { ConditionSatisfactionHelper } from '@medely/credentials-tools';

export enum MissingConditionStatus {
  InReview = 'in_review',
  ExpiringSoon = 'expiring_soon',
  NeedsAttention = 'needs_attention',
  Expired = 'expired',
  Completed = 'completed',
  Missing = 'missing',
}

type GetMissingConditionStatusArgs = {
  condition: ICondition;
  professionalQualifications: IProfessionalQualification[];
  satisfiedConditionIds: number[];
  expiringConditionIds: number[];
};

export const getConditionProfessionalQualifications = (
  condition: ICondition,
  professionalQualifications: IProfessionalQualification[],
) => {
  const conditionQualificationsIds = condition.qualifications.map(
    (qualification) => qualification.id,
  );
  return professionalQualifications.filter((qualification) =>
    conditionQualificationsIds.includes(qualification.qualification.id),
  );
};

export const getMissingConditionStatus = ({
  condition,
  professionalQualifications,
  satisfiedConditionIds,
  expiringConditionIds,
}: GetMissingConditionStatusArgs): MissingConditionStatus => {
  const conditionHelper = new ConditionSatisfactionHelper({
    condition,
    professionalQualifications,
    satisfiedConditionIds,
    expiringSoonConditionIds: expiringConditionIds,
  });

  if (conditionHelper.isAwaitingReviewCheckExpiringSoon) {
    return MissingConditionStatus.InReview;
  }

  if (expiringConditionIds.includes(condition.id)) {
    return MissingConditionStatus.ExpiringSoon;
  }

  if (conditionHelper.unsatisfiedDueToRejectedPq) {
    return MissingConditionStatus.NeedsAttention;
  }

  if (conditionHelper.unsatisfiedDueToExpiredPq) {
    return MissingConditionStatus.Expired;
  }

  if (conditionHelper.isSatisfied) {
    return MissingConditionStatus.Completed;
  }

  if (
    getConditionProfessionalQualifications(condition, professionalQualifications).some((pq) =>
      ['rejected', 'expired'].includes(pq.status),
    )
  ) {
    return MissingConditionStatus.NeedsAttention;
  }

  return MissingConditionStatus.Missing;
};
